import {
  Storage,
} from '@webrcade/app-common'

const storage = new Storage();

export { storage }